import styled from 'styled-components';
import { createGradientOrSolid } from '../Helper/utils/utils';

export const StyledAddToHomePageButton = styled.button`
  display: flex;
  align-items: center;
    width: auto;
    min-width: 116px;
  text-align: left;
  position: fixed;
  bottom: 8px;
  left: 16px;
  border-radius: 36px;
  padding: 4px 6px 4px 4px;
  z-index: 30;
  border: 2px solid #fff;
  background: ${(props: any) => createGradientOrSolid(props?.bgColor, true)};
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);

  .description {
    font-family: var(--font-family), Arial;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    color: #fff;
    padding: 0 4px;
  }
` as any;
